/**
 * Setup Location page constants (NXTGEN-5822).
 */

export const RIGHT = 'financialclose_location_master';

/** Activity log modulename stored on each location log entry. */
export const ACTIVITY_LOG_MODULE_NAME = 'financialclose_location_master';

export const ITEMS_PER_PAGE = 13;

export const TABLE_HEADERS = [
  {
    value: 'name',
    text: 'Name',
    visible: true,
    filterable: true,
    sortable: true,
  },
  {
    value: 'description',
    text: 'Description',
    visible: true,
    filterable: true,
    sortable: true,
  },
  {
    value: 'type',
    text: 'Type',
    visible: true,
    filterable: true,
    sortable: true,
  },
  {
    value: 'country',
    text: 'Country',
    visible: true,
    filterable: true,
    sortable: true,
  },
  {
    value: 'threshold',
    text: 'Threshold',
    visible: true,
    filterable: true,
    sortable: true,
  },
  {
    value: 'thresholdStatus',
    text: 'Set Threshold',
    visible: false,
    filterable: true,
    sortable: true,
  },
  {
    value: 'scource',
    text: 'Source',
    visible: false,
    filterable: true,
    sortable: true,
  },
  {
    value: 'ingestion_type',
    text: 'Ingestion Type',
    visible: true,
    filterable: true,
    sortable: true,
  },
  {
    value: 'action',
    text: 'Action',
    sortable: false,
    datatype: 'action',
    lock: true,
    visible: true,
    alignment: 'text-center',
  },
];

export const PAGE_DETAILS = {
  pagename: 'location-master',
  cycle_id: 'global',
};

/** Appended to Excel export only (status is shown as a toggle in the table). */
export const LOCATION_EXPORT_STATUS_HEADER = {
  value: 'status',
  text: 'Status',
};

/** Excel export table header — dark brand fill, white bold text (matches FBC export templates). */
export const LOCATION_EXPORT_HEADER_STYLE = {
  font: { bold: true, color: { rgb: 'FFFFFF' } },
  fill: {
    patternType: 'solid',
    fgColor: { rgb: 'FF193541' },
  },
  alignment: {
    horizontal: 'left',
    vertical: 'center',
  },
};
